/* Jhilke Studio — restrained gallery motion layer (v3).
   Small scroll reveals, one-time accents, light 3D hover depth, and subtle
   media parallax support the artwork without competing with it. Every effect
   is enhancement-only, reduced-motion-aware, and safe to fail open. */
(function () {
  'use strict';
  try {
    var root = document.documentElement;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var hasIO = 'IntersectionObserver' in window;
    if (reduce || !hasIO) return; // leave the page fully visible, no motion

    root.classList.add('jh-fx');
    function each(list, fn) { Array.prototype.forEach.call(list, fn); }

    // ---- Titles get a clip-wipe reveal ----
    var HEAD = [
      '.jh-hero-copy h1', '.jh-showcase__title', '.jh-story-copy h2',
      '.jh-collections-head h2', '.jh-fav-head h2', '.jh-trust__title',
      '.jh-wall__title', '.jh-ugc__title',
      '.jh-him-hero h1', '.jh-him-finishes-head h2', '.jh-him-sizing-copy h2',
      '.jh-returns h1', '.jh-faq-hero h1'
    ]; // NB: the Story page (.jh-sp-*) runs its own reveal system — left untouched.
    // NB 2: the collection hero (.jh-col-hero-*) now runs on ScrollCraft
    // (scrubbed) — its elements are no longer tagged here.
    // ---- Small accents pop in ----
    var POP = [
      '.jh-hero-kicker', '.jh-collections-eyebrow', '.jh-fav-eyebrow',
      '.jh-trust__eyebrow', '.jh-wall__eyebrow', '.jh-showcase__eyebrow',
      '.jh-story-eyebrow',
      '.jh-him-kicker', '.jh-fav-badge', '.jh-collection-badge'
    ];
    // ---- A few small decorative accents drift; primary art remains still ----
    var FLOAT_ROT = ['.jh-hero-sparkle', '.jh-col-hero-sparkle', '.jh-showcase__eyebrow .jhilke-glint'];
    // ---- Everything else rises + scales + un-blurs ----
    var BASE = [
      // homepage
      '.jh-hero-body', '.jh-hero-actions', '.jh-hero-stats', '.jh-hero-media',
      '.jh-collection-card', '.jh-collections-sub',
      '.jh-story-media', '.jh-story-copy p', '.jh-story-cta',
      '.jh-showcase__body', '.jh-showcase__cta',
      '.jh-fav-card',
      '.jh-craft-step', '.jh-promise', '.jh-trust__lead', '.jh-trust__cta',
      '.jh-ugc__card', '.jh-faq__item',
      // collection + product + editorial (col-hero is ScrollCraft-owned now)
      '.product-card',
      '.jh-him-step', '.jh-him-finish-card', '.jh-him-sizing-media', '.jh-him-cta-wrap',
      // existing hand-tagged
      '.jh-reveal'
    ];

    function tagHead() {
      each(document.querySelectorAll(HEAD.join(',')), function (el) {
        if (el.__jhTag) return;
        el.classList.remove('jh-reveal');
        if (el.closest('.jh-reveal')) { el.__jhTag = 1; return; } // avoid nesting under a base reveal
        el.classList.add('jh-reveal--head'); el.__jhTag = 1;
      });
    }
    function tagPop() {
      each(document.querySelectorAll(POP.join(',')), function (el) {
        if (el.__jhTag) return;
        el.classList.remove('jh-reveal');
        el.classList.add('jh-pop'); el.__jhTag = 1;
      });
    }
    function tagBase() {
      each(BASE, function (sel) {
        var seen = new Map();
        each(document.querySelectorAll(sel), function (el) {
          if (el.__jhTag && sel !== '.jh-reveal') return;
          if (el.classList.contains('jh-reveal--head') || el.classList.contains('jh-pop')) return;
          if (sel !== '.jh-reveal') el.classList.add('jh-reveal');
          // stagger siblings within a parent
          var p = el.parentElement || document.body;
          var i = seen.get(p) || 0;
          if (!el.style.getPropertyValue('--jh-d')) {
            // stagger the cascade, but cap it so big grids never lag behind
            el.style.setProperty('--jh-d', Math.min(i * 65, 300) + 'ms');
          }
          seen.set(p, i + 1);
          el.__jhTag = 1;
        });
      });
    }

    var io = null;
    function setupReveal() {
      if (!io) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { en.target.classList.add('jh-in'); io.unobserve(en.target); }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.02 });
      }
      each(document.querySelectorAll('.jh-reveal:not(.jh-in), .jh-reveal--head:not(.jh-in), .jh-pop:not(.jh-in)'), function (el) {
        io.observe(el);
      });
    }

    // ---- 3D hover tilt ----
    function setupTilt() {
      if (!finePointer) return;
      var sel = '.jh-craft-step, .jh-promise, .jh-ugc__card, .jh-fav-media, .jh-collection-card';
      each(document.querySelectorAll(sel), function (card) {
        if (card.__jhTilt) return; card.__jhTilt = true;
        card.classList.add('jh-tilt');
        var raf = null, rect = null;
        function onMove(e) {
          if (!rect) rect = card.getBoundingClientRect();
          var px = (e.clientX - rect.left) / rect.width - 0.5;
          var py = (e.clientY - rect.top) / rect.height - 0.5;
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
        var max = 3;
            card.style.setProperty('--jh-ry', (px * max).toFixed(2) + 'deg');
            card.style.setProperty('--jh-rx', (-py * max).toFixed(2) + 'deg');
          });
        }
        card.addEventListener('pointerenter', function () { rect = card.getBoundingClientRect(); card.classList.add('jh-tilt--active'); });
        card.addEventListener('pointermove', onMove);
        card.addEventListener('pointerleave', function () {
          rect = null; card.classList.remove('jh-tilt--active');
          card.style.setProperty('--jh-rx', '0deg'); card.style.setProperty('--jh-ry', '0deg');
        });
      });
    }

    // ---- Continuous floating on decorative accents ----
    function setupFloat() {
      var i = 0;
      each(document.querySelectorAll(FLOAT_ROT.join(',')), function (el) {
        if (el.__jhFloat) return; el.__jhFloat = 1;
        el.classList.add('jh-float--rot');
        el.style.animationDelay = ((i % 5) * 0.6).toFixed(2) + 's';
        el.style.animationDuration = (6 + (i % 3) * 0.7).toFixed(2) + 's';
        i++;
      });
    }

    // ---- Opt-in parallax on explicit [data-jh-parallax] ----
    function setupParallax() {
      var items = document.querySelectorAll('[data-jh-parallax]');
      if (!items.length) return;
      var ticking = false;
      function update() {
        ticking = false;
        var vh = window.innerHeight;
        // read every position first, then write, so the loop forces one layout, not one per item
        var rects = [];
        each(items, function (el) { rects.push(el.getBoundingClientRect()); });
        each(items, function (el, n) {
          var r = rects[n];
          if (r.bottom < -200 || r.top > vh + 200) return;
          var factor = Math.min(parseFloat(el.getAttribute('data-jh-parallax')) || 0.05, 0.055);
          var center = r.top + r.height / 2;
          var delta = Math.max(-22, Math.min(22, (center - vh / 2) * factor));
          el.style.transform = 'translate3d(0,' + (-delta).toFixed(1) + 'px,0)';
        });
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }

    function boot() {
      tagHead(); tagPop(); tagBase();
      setupReveal();
      setupTilt();
      setupParallax();
      setupFloat();
      // Fail-safe: never leave anything hidden.
      setTimeout(function () {
        var hidden = document.querySelectorAll('.jh-reveal:not(.jh-in), .jh-reveal--head:not(.jh-in), .jh-pop:not(.jh-in)');
        var tops = [], vh = window.innerHeight;
        each(hidden, function (el) { tops.push(el.getBoundingClientRect().top); });
        each(hidden, function (el, n) { if (tops[n] < vh + 40) el.classList.add('jh-in'); });
      }, 1800);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();

    document.addEventListener('shopify:section:load', function () {
      setTimeout(function () { tagHead(); tagPop(); tagBase(); setupReveal(); setupTilt(); setupFloat(); }, 30);
    });
  } catch (err) { /* fail silent — never block the page */ }
})();

/* Jhilke Studio — site-wide media parallax (fail-safe).
   Gives framed imagery a gentle depth-drift on scroll across the collection
   hero, Story page and How-it's-made page, without editing their markup. Each
   image is pre-scaled so the drift can never expose an edge; any frame that
   doesn't clip its overflow is skipped. */
(function () {
  try {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var SELECTORS = [
      '.jh-sp-essay-media',
      '.jh-him-finish-media', '.jh-him-sizing-media'
    ].join(','); // col-hero frame, sp-origin frame + sp-banner frame are ScrollCraft-owned
    var SCALE = 1.08, MAX = 8, items = [];
    function collect() {
      items = [];
      Array.prototype.forEach.call(document.querySelectorAll(SELECTORS), function (box) {
        if (box.__jhMP) { items.push(box.__jhMP); return; }
        if (box.closest('[data-jh-parallax]')) return;
        var img = box.querySelector('img');
        if (!img) return;
        var cs = window.getComputedStyle(box);
        if (cs.overflow === 'visible') return;
        if (cs.position === 'static') box.style.position = 'relative';
        img.style.willChange = 'transform';
        img.style.transform = 'scale(' + SCALE + ')';
        var rec = { box: box, img: img }; box.__jhMP = rec; items.push(rec);
      });
    }
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var rects = items.map(function (it) { return it.box.getBoundingClientRect(); }); // reads first, then writes
      items.forEach(function (it, n) {
        var r = rects[n];
        if (r.bottom < -120 || r.top > vh + 120) return;
        var center = r.top + r.height / 2;
        var prog = (center - vh / 2) / vh;
        var shift = prog * 14;
        if (shift > MAX) shift = MAX; else if (shift < -MAX) shift = -MAX;
        it.img.style.transform = 'scale(' + SCALE + ') translate3d(0,' + (-shift).toFixed(1) + 'px,0)';
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    function init() {
      collect(); if (!items.length) return; update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { collect(); onScroll(); }, { passive: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', function () { setTimeout(init, 40); });
  } catch (err) {}
})();
